import { makeStyles } from '@material-ui/core/styles';
import { light } from '@material-ui/core/styles/createPalette';
import { BackgroundColors, SecondaryColors, SurfaceColors, Theme } from '@/utils/constants';

const lightTheme = {
  root: {
    '& $buttonMobile': {
      color: SecondaryColors.dark,
    },
    '& $icon': {
      color: SecondaryColors.dark,
    },
    '& $iconImage.MuiSvgIcon-root': {
      color: SecondaryColors.dark,
    },
  },
};

const darkTheme = {
  root: {
    '& $buttonMobile': {
      color: SecondaryColors.main,
    },
    '& $icon': {
      color: SecondaryColors.main,
    },
    '& $iconImage.MuiSvgIcon-root': {
      color: SecondaryColors.main,
    },
  },
};

export const useSearchBarStyles = makeStyles(
  (muiTheme) => ({
    root: {
      background: SurfaceColors.light,
      border: 'none',
      height: '45px',
      borderRadius: '1.5em',
      overflow: 'hidden',

      [muiTheme.breakpoints.up('md')]: {
        borderRadius: 0,
        height: '70px',
      },

      '& .MuiInputBase-input': {
        paddingRight: muiTheme.spacing(6.5),

        [muiTheme.breakpoints.up('md')]: {
          paddingRight: muiTheme.spacing(1),
        },
      },
    },
  }),
  { name: 'GenSDLSearchBarStyles' },
);

const useStyles = makeStyles(
  (muiTheme) => ({
    wrapper: {
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,
      width: '100%',
      display: 'flex',
      height: 'auto',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignContent: 'stretch',

      [muiTheme.breakpoints.up('md')]: {
        height: '70px',
      },

      [muiTheme.breakpoints.down('sm')]: {
        marginLeft: muiTheme.spacing(-4),
        marginRight: muiTheme.spacing(-4),
        width: `calc(100% + ${muiTheme.spacing(8)}px)`,
      },
    },
    inputWrapper: {
      flex: 1,
      position: 'relative',
      padding: muiTheme.spacing(0, 4),

      [muiTheme.breakpoints.up('md')]: {
        padding: 0,
      },
    },
    buttonMobile: {
      '&.MuiButtonBase-root': {
        fontSize: '12px',
        position: 'absolute',
        right: muiTheme.spacing(4),
        top: 0,
        bottom: 0,
        padding: muiTheme.spacing(0, 3),
        zIndex: 4,

        [muiTheme.breakpoints.up('md')]: {
          display: 'none',
        },
      },
    },
    button: {
      '&.MuiButtonBase-root': {
        height: '100%',
        boxShadow: 'none',
        borderRadius: 0,
        width: '200px',

        '&:hover': {
          boxShadow: 'none',
        },
      },
    },
    icon: {
      marginLeft: muiTheme.spacing(2),
    },
    iconImage: {
      '& .MuiSvgIcon-root': {
        fontSize: '1.8rem',
      },
    },
    mobileBar: {
      marginTop: muiTheme.spacing(3.5),
      width: '100%',
    },
    chips: {
      margin: muiTheme.spacing(2.5, 0, 1.5),
      width: '100%',
    },
    mobile: {
      display: 'none',
      [muiTheme.breakpoints.up('md')]: {
        display: 'inline',
        marginRight: muiTheme.spacing(1),
      },
    },
  }),
  { name: 'GenSDLSearchBar' },
);

export default useStyles;
